module.exports = __webpack_public_path__ + "mo/img/brand02.082c0e24.png";